import React from "react";
import * as Sentry from "@sentry/react";
import AppErrorScreen from "./appErrorScreen.jsx";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo?.componentStack },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <AppErrorScreen
          title="Something broke in the application."
          message={
            this.state.error?.message ||
            "An unexpected error occurred. Please reload the page and try again."
          }
          statusCode={500}
        />
      );
    }

    return this.props.children;
  }
}
